var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#212121",
    stroke: "#424242"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.88889C12.0727 8.88889 8.88889 12.0727 8.88889 16C8.88889 19.3348 11.1849 22.1332 14.2822 22.9018V18.1732H12.8159V16H14.2822V15.0636C14.2822 12.6433 15.3776 11.5214 17.7539 11.5214C18.2044 11.5214 18.9818 11.6099 19.2998 11.6981V13.6678C19.132 13.6502 18.8405 13.6414 18.4784 13.6414C17.3124 13.6414 16.8619 14.0831 16.8619 15.2314V16H19.1846L18.7856 18.1732H16.8619V23.0591C20.383 22.6338 23.1114 19.6358 23.1114 16C23.1111 12.0727 19.9273 8.88889 16 8.88889Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_1171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2222,
    height: 14.2222,
    fill: "white",
    transform: "translate(8.88889 8.88889)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5723dde4d4fb95241cb9340fccb4805f.svg";
export { ForwardRef as ReactComponent };